<template>
  <BravadoTheme forced-theme="light" class="layout layout--default">
    <ClientOnly>
      <TopNotification />
    </ClientOnly>
    <Header />
    <div class="layout__container">
      <div class="layout__content">
        <div class="layout__content-wrapper">
          <Nuxt />
        </div>
        <Footer v-if="isFooterVisible" class="layout__footer" />
      </div>
    </div>
    <GlobalComponents />
  </BravadoTheme>
</template>

<script>
import defaultLayoutMixin from '~/layouts/defaultLayoutMixin';

export default {
  name: 'DefaultLayoutLight',
  components: {
    Footer: () => import('@/components/global/Footer/Footer'),
  },
  mixins: [defaultLayoutMixin],
};
</script>

<style lang="scss" scoped>
.layout {
  position: relative;
  z-index: 1;

  &__container {
    z-index: 1;
    position: relative;

    @include mq('md') {
      display: flex;
    }
  }

  &__content {
    @include mq('md') {
      flex: 1;
    }
  }

  &__content-wrapper {
    position: relative;
  }
}
</style>
